import React from 'react';

import {CardText, CardTitle, FormGroup, Input, Label} from 'reactstrap';
import renderExplanation from './Explanation';

const SelectableTask = ({title, description, options, correctOptionIds=[], type, showCorrect, explanation, display = 'block'}) => {
    const isCorrect = (id) => showCorrect && correctOptionIds.includes(id);
    const correctOption = (id) => options.find((option) => option.id === id);
    const getFirstCorrectOption = () => {
        const correctOptionValue = correctOption(correctOptionIds & correctOptionIds[0]) || '';
        return correctOptionValue.value || ''
    }

    const renderOptions = () => {
        if (type === 'select') {
            return <FormGroup>
                {showCorrect ? <Label for={title} className='Task--correct'>Ats.: {getFirstCorrectOption()}</Label> : undefined}
                <Input type={type} name={title} id={title}>
                    {
                        options.map(({id, value}) => (
                            <option key={id}>{value}</option>
                        ))
                    }
                </Input>
            </FormGroup>
        } else {
            return options.map(({id, value}) => (<FormGroup check key={id}>
                <Label check className={isCorrect(id)? 'Task--correct': ''}>
                    <Input type={type === 'highlight' ? 'checkbox' : type} name={title + description}/>
                    <span dangerouslySetInnerHTML={{ __html: value }} />
                </Label>
            </FormGroup>))
        }
    }

    return <div className={`Task--${type}`}>
        <CardTitle dangerouslySetInnerHTML={{ __html: title }} />
        <div className={`Task--display-${display}`}>
            {description? <CardText dangerouslySetInnerHTML={{ __html: description }} /> : undefined}
            <div className="Task__options">{renderOptions()}</div>
        </div>
        {(showCorrect && explanation)? renderExplanation(explanation) : undefined}
    </div>
}

export default SelectableTask;